<template>
  <div class="position-relative">
    <div :id="mapId" class=" mapbox-component">
      <div  :class="config.type=='detail' || viewMode=='detail'?'d-none':'marker-custom'"></div>
      <!-- <div class="marker-custom"></div> -->
      <!--      <div class="input-group mb-3 input-search" >-->
      <!--      <input type="text" class="form-control" aria-label="Text input with checkbox">-->
      <!--      </div>-->
    </div>
  </div>
</template>
<style scoped>
.mapbox-component {
  position: relative;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 500px;
}
.marker-custom {
  top: 40%;
  left: 45%;
  position: absolute;
  background-image: url('../../public/img/marker.png');
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}
::v-deep .mapboxgl-marker {
  /* top: 31%;
    left: 45%;
    position: absolute; */
  background-image: url("../../public/img/marker.png");
  /* background-size: cover; */
  background-size: 35px 35px;
  background-position: center;
  width: 27px;
  height: 35px;
  cursor: pointer;
  z-index: 1;
}

::v-deep .mapboxgl-marker svg{
  display: none;
}
/*.input-search {*/
/*top: 5px;*/
/*right: 5px;*/
/*position: absolute;*/
/*background-size: cover;*/
/*width: auto;*/
/*height: 50px;*/
/*border-radius: 50%;*/
/*cursor: pointer;*/
/*z-index: 1;*/
/*opacity: 95%;*/
/*}*/
</style>
<script>
import mapboxgl from "mapbox-gl";
import MapApi from "../moduleApi/MapApi";
import MethodService from "../service/MethodService";

export default {
  props: {
    value: Object,
    cordinatesValue: Array,
    id: String,
    config:Object,
    viewMode: String,
    // type: String
  },
  data() {
    return {
      mData: {
        dataDefault: {
          token:
            "pk.eyJ1Ijoic2l0ZW5zYyIsImEiOiJjbDV2dHlja3MwZDdiM2lwOWtqaGJ4dTNnIn0.baIM03zTvYrPzEJZOlDtYw",
          style: {
              'version': 8,
              'sources': {
                  'raster-tiles': {
                      'type': 'raster',
                      'tiles': [
                          'https://api.ipostmap.vn/sdk/tile/raster/{z}/{x}/{y}?key=b7936cda802069001c98f3ff3ca3ac41'
                      ],
                      'tileSize': 256,
                      'attribution': ''
                  }
              },
              'layers': [
                  {
                      'id': 'simple-tiles',
                      'type': 'raster',
                      'source': 'raster-tiles',
                      'minzoom': 0,
                      'maxzoom': 22
                  }
              ]
          },
          mapDataObject: {
            value: [],
            geoJsonData: {
              type: "",
              geometry: {}
            }
          },
          cordinatesValueProps: []
        }
      },
      mapId: this.id ? this.id : "map_" + parseInt(Math.random() * 1e6),
      map: null,
    };
  },

  methods: {
    async fn_initMap(map) {
      var _this = this;
      if(_this.map){
        _this.map.remove();
      }
      mapboxgl.accessToken = this.mData.dataDefault.token;
      if (MethodService.isUndefined(map)) {
        // debugger
        const isValidCoords = Array.isArray(_this.cordinatesValue) && 
                              _this.cordinatesValue.length === 2 && 
                              typeof _this.cordinatesValue[0] === 'number' && !isNaN(_this.cordinatesValue[0]) &&
                              typeof _this.cordinatesValue[1] === 'number' && !isNaN(_this.cordinatesValue[1]) &&
                              _this.cordinatesValue[0] >= -180 && _this.cordinatesValue[0] <= 180 &&
                              _this.cordinatesValue[1] >= -90 && _this.cordinatesValue[1] <= 90;
        _this.map = new mapboxgl.Map({
          container: this.mapId, // container id
          style: _this.mData.dataDefault.style, // stylesheet location
          center: isValidCoords
            ? _this.cordinatesValue
            : [105.75, 21], // starting position [lng, lat]
          zoom: 15 // starting zoom
        });
        // map.scrollZoom.disable();

        if(this.viewMode == "detail" ||  this.config.type =='detail'){
          new mapboxgl.Marker()
          .setLngLat(
            isValidCoords
              ? _this.cordinatesValue
              : [105.75, 21]
          )
          .addTo(_this.map);
        }

      }
      let geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        marker: null,
        mapboxgl: mapboxgl
      });
      _this.map.addControl(geocoder);

      _this.map.addControl(new mapboxgl.NavigationControl());
      _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
        _this.map
      );
      _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      _this.map.on("mouseup", async function(e) {
        _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
          _this.map
        );
        _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      });
      _this.map.on("wheel", async function(e) {
        _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
          _this.map
        );
        _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      });
      _this.map.on("load", function() {
        // Listen for the `result` event from the Geocoder
        // `result` event is triggered when a user makes a selection
        //  Add a marker at the result's coordinates
        geocoder.on("result", async function(e) {
          let res = await MapApi.searchByLngLat(
            {
              long: e.result.center[0],
              lat: e.result.center[1]
            },
            mapboxgl.accessToken
          );
          let featureLast = res.features.pop();
          let result = {
            value: [e.result.center[0], e.result.center[1]],
            geoJson: {
              type: featureLast && featureLast.geometry && featureLast.geometry.type,
              coordinates: res.query
            }
          };
          _this.mData.dataDefault.mapDataObject = result;
          _this.$emit("update", _this.mData.dataDefault.mapDataObject);
          console.log("_this.mData.dataDefault.mapDataObject",_this.mData.dataDefault.mapDataObject);
        });
        _this.map.resize();
      });
      console.log("map",map);
      _this.mData.mapBox = map;
    },
    fn_isNull(value) {
      return MethodService.isNull(value);
    },

    async fn_getGeoJsonData(map) {
      let result = await MapApi.searchByLngLat(
        {
          long: map.getCenter().lng,
          lat: map.getCenter().lat
        },
        mapboxgl.accessToken
      );
      let featureLast = result.features.pop();
      return {
        value: [map.getCenter().lng, map.getCenter().lat],
        geoJson: {
          type: featureLast && featureLast.geometry && featureLast.geometry.type,
          coordinates: result.query
        }
      };
    }
  },
  created() {},
  mounted: async function() {
    await this.fn_initMap();
  },
  watch: {
      "$store.state.mapBox.refreshMapBox": async function(newVal, oldVal) {
          var _this = this;
          if (newVal && newVal != oldVal) {
            await _this.fn_initMap();
          }
      },
    },
};
</script>


